import { SessionStorageEntityIdResolver } from '../../resolvers/session-storage-entityid/session-storage-entityid.resolver';

export const notFoundRoute = {
  path: 'not-found',
  url: '/not-found',
  resolve: {
    entityId: SessionStorageEntityIdResolver,
  },
  loadChildren: () => import('../../../shared/components/not-found/not-found.module').then(m => m.NotFoundModule),
};
